import useFormEditPage from '@/hooks/use-form-edit-page';
import { produce } from 'immer';

import { useCallback, useMemo } from 'react';

/**
 * Form-edit-context-specific hook.
 * Derives the currently selected locations from formEditDetails and
 * provides a handler that persists changes via the form edit API.
 */
export function useFormLocations() {
	const { formEditDetails, handleUpdateFormEditDetails } = useFormEditPage();

	const selectedLocations = useMemo(
		() => formEditDetails?.locations ?? [],
		[formEditDetails?.locations]
	);

	const handleLocationsUpdate = useCallback(
		(locations: string[]) => {
			if (!formEditDetails) return;

			const updatedFormEditDetails = produce(formEditDetails, (draft) => {
				draft.locations = locations;
			});

			handleUpdateFormEditDetails({
				updatedFormEditDetails,
				errorText: 'Failed to update location',
			});
		},
		[formEditDetails, handleUpdateFormEditDetails]
	);

	return { selectedLocations, handleLocationsUpdate };
}
